import { render, staticRenderFns } from "./confirmPhoto.vue?vue&type=template&id=46f1f889&"
import script from "./confirmPhoto.vue?vue&type=script&lang=ts&"
export * from "./confirmPhoto.vue?vue&type=script&lang=ts&"
import style0 from "./confirmPhoto.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports